import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import { Label } from '@hydra/common/components';
import { Grid } from '@material-ui/core';
import get from 'lodash/get';

import List from '@hydra/routes/crawler/components/List';
import parseSeverity from '@hydra/routes/crawler/utils/parseSeverity';
import DCUrl from '@hydra/routes/crawler/utils/DCUrl';

export class Http4xxErrorsRow extends React.Component {
  static propTypes = {
    issue: PropTypes.object,
    columnStyles: PropTypes.array,
    relay: PropTypes.object
  }

  render () {
    const {
      columnStyles,
      issue,
      className: classNameProp
    } = this.props;

    const domain = get(this.props, ['relay', 'route', 'params', 'url'], '');
    const errorUrl = new DCUrl(domain, issue.error_url);
    const sourceUrl = new DCUrl(domain, issue.source_url);

    return (
      <Grid container className={classNameProp} alignItems='flex-start'>
        <Grid item {...columnStyles[0]}>
          <Label noBackground style={parseSeverity(issue.severity)}>
            <strong>
              {issue.code}
            </strong>
          </Label>
        </Grid>
        <Grid item {...columnStyles[1]}>
          <List style='grey' items={errorUrl} />
        </Grid>
        <Grid item {...columnStyles[2]}>
          <List style={parseSeverity(issue.severity)} items={sourceUrl} />
        </Grid>
      </Grid>
    );
  }
}

export default createFragmentContainer(Http4xxErrorsRow, {
  issue: graphql`
    fragment Http4xxErrorsRow_issue on Http4xxError {
      id
      type
      severity
      code
      internal
      error_url
      source_url
    }
  `
});
